import * as React from 'react';
import * as styles from './styles.css';

import { ErrorPopover } from '../ErrorPopover';
import { Input, InputAdornment } from '@cian/ui-kit';
import { TAreaInputComponentProps } from 'shared/common/utils/types';

export function AreaInput({
  onBlur,
  value,
  onValueChange,
  unit,
  errorMessage,
  placeholder,
  ref,
}: TAreaInputComponentProps): React.JSX.Element {
  return (
    <div className={styles['container-mobile']}>
      <ErrorPopover tooltipContent={errorMessage}>
        <Input
          ref={ref}
          value={value}
          onBlur={onBlur}
          onChange={e => onValueChange(e.target.value)}
          maxLength={4}
          placeholder={placeholder || '77'}
          rightAdornment={<InputAdornment>{unit}</InputAdornment>}
          size="M"
          invalid={Boolean(errorMessage)}
          data-testid="area_input"
        />
      </ErrorPopover>
    </div>
  );
}
